import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { GalleryService } from '../../services/gallery';

interface GalleryImage {
  id: number;
  title: string;
  imageUrl: string;
  sortOrder: number;
}

interface GalleryRequest {
  title: string;
  imageUrl: string;
  sortOrder: number;
}

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule
  ],
  templateUrl: './gallery.html',
  styleUrls: ['./gallery.scss']
})
export class GalleryComponent implements OnInit {

  images: GalleryImage[] = [];

  gallery: GalleryRequest = {
    title: '',
    imageUrl: '',
    sortOrder: 0
  };

  selectedImageId: number | null = null;

  uploading = false;
  saving = false;

  constructor(
    private galleryService: GalleryService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadImages();
  }

  loadImages(): void {

    this.galleryService.getImages().subscribe({

      next: (data: any) => {

        this.images = data;

      },

      error: (err) => {

        console.error(err);

      }

    });

  }

uploadImage(event: Event): void {

  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0)
    return;

  const file = input.files[0];

  this.uploading = true;

  this.galleryService.uploadImage(file)
    .subscribe({

      next: (response: any) => {

        this.gallery.imageUrl = response.secure_url;

        this.uploading = false;

        this.cdr.detectChanges();

      },

      error: (err) => {

        console.error(err);

        this.uploading = false;

      }

    });

}

  save(): void {

    if (this.uploading)
      return;

    this.saving = true;

    if (this.selectedImageId == null) {

      this.galleryService.createImage(this.gallery)
        .subscribe({

          next: () => {

            this.loadImages();

            this.clearForm();

          },

          error: (err) => {

            console.error(err);

            this.saving = false;

          }

        });

    }
    else {

      this.galleryService.updateImage(
        this.selectedImageId,
        this.gallery
      )
      .subscribe({

        next: () => {

          this.loadImages();

          this.clearForm();

        },

        error: (err) => {

          console.error(err);

          this.saving = false;

        }

      });

    }

  }

  edit(image: GalleryImage): void {

    this.selectedImageId = image.id;

    this.gallery = {
      title: image.title,
      imageUrl: image.imageUrl,
      sortOrder: image.sortOrder
    };

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  }

  delete(id: number): void {

    if (!confirm('Da li želite da obrišete ovu sliku?'))
      return;

    this.galleryService.deleteImage(id)
      .subscribe({

        next: () => {

          this.loadImages();

        },

        error: (err) => {

          console.error(err);

        }

      });

  }

  clearForm(): void {

    this.selectedImageId = null;

    this.gallery = {
      title: '',
      imageUrl: '',
      sortOrder: 0
    };

    this.uploading = false;
    this.saving = false;

    this.cdr.detectChanges();

  }

}